import { UserRole } from 'shared/constants';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001/api';

export const useGoogleAuth = () => {
  const handleGoogleLogin = (role: UserRole = UserRole.CLIENT) => {
    window.location.href = `${API_BASE_URL}/auth/google?role=${role}`;
  };

  return { handleGoogleLogin };
};
